import { Radio } from '@mantine/core';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import { FilterSection } from './FilterSection';
import { ALL_NETWORKS } from '@/app/constants';
import filterClasses from './Filter.module.css';
import classes from './Network.module.css';
import type { UseFormRegister } from 'react-hook-form';
import type { FilterState } from '@/features/filterSlice';
import type {
  TRANSMISSION_CLIENT,
  DISTRIBUTION_CLIENT,
} from '@/features/types';

export const Network = ({
  networks,
  register,
}: {
  networks: Record<
    number,
    typeof TRANSMISSION_CLIENT | typeof DISTRIBUTION_CLIENT
  >;
  register: UseFormRegister<FilterState>;
}) => {
  const intl = useClientTerminology();

  return (
    <FilterSection>
      <span className={filterClasses.heading}>Network type</span>
      <Radio
        {...register('network')}
        key={ALL_NETWORKS}
        value={ALL_NETWORKS}
        label={intl.formatMessage({ id: 'filter.allNetworkOption' })}
        data-testid="filter-network-all"
        className={classes.networkRadio}
      />
      {Object.entries(networks).map(([key, value]) => (
        <Radio
          {...register('network')}
          key={value}
          value={key}
          label={intl.formatMessage({ id: `filter.${value}Option` })}
          data-testid={`filter-network-${key}`}
          className={classes.networkRadio}
        />
      ))}
    </FilterSection>
  );
};
